// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ehIJ849ztreNgt {
  position: relative;
  max-width: 240px;
  padding: 8px 12px;
  overflow: hidden;
}
.ehIJ849ztreNgt h3 {
  font-size: 14px;
}
.ehIJ849ztreNgt p {
  margin-bottom: 12px;
}
.ehIJ849ztreNgt .Mtu9SJpaqK4LWC {
  margin-right: 32px;
  margin-bottom: 4px;
}
.ehIJ849ztreNgt .Mtu9SJpaqK4LWC a {
  color: var(--ds-text-subtle, #44546f);
  text-decoration: underline;
}
.ehIJ849ztreNgt .Mtu9SJpaqK4LWC a:hover {
  color: var(--ds-text, #172b4d);
}
.ehIJ849ztreNgt .P4Rb3tHMduKxLP {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 24px;
  height: 24px;
  border-radius: var(--ds-border-radius-050, 2px);
  background: var(--ds-background-accent-purple-bolder, #5e4db2);
}
.ehIJ849ztreNgt .x9Lbj7YHUtxJhl {
  position: absolute;
  z-index: 1;
  right: -28px;
  bottom: -64px;
  width: 120px;
  height: 80px;
  transform: rotate(-50deg);
  border-radius: 12px;
  background: var(--ds-background-neutral, #091e420f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContent": `ehIJ849ztreNgt`,
	"ctaContainer": `Mtu9SJpaqK4LWC`,
	"iconContainer": `P4Rb3tHMduKxLP`,
	"iconBackground": `x9Lbj7YHUtxJhl`
};
export default ___CSS_LOADER_EXPORT___;
